import React from 'react';
import { SubmitHandler } from 'react-hook-form';
import {
  CodeErrors,
  AUTH_VALIDATION_CONFIG
} from '../auth/forms/validation.pattern';

type Inputs = {
  code: string;
};

export const useCodeRegister = ({
  register,
  throttledResendCode,
  throttledSubmit,
  handleSubmit,
  setValue,
  email
}: {
  register: any;
  throttledResendCode: (email: string) => void;
  throttledSubmit: (data: { code: string }) => void;
  handleSubmit: any;
  setValue: any;
  email?: string;
}) => {
  const [formattedValue, setFormattedValue] = React.useState('');

  const codeRegister = register.bind(null, 'code', {
    required: { message: CodeErrors.required, value: true },
    minLength: {
      value: AUTH_VALIDATION_CONFIG.sixDigitCode.length,
      message: CodeErrors.incorrect
    },
    maxLength: {
      value: AUTH_VALIDATION_CONFIG.sixDigitCode.length,
      message: CodeErrors.incorrect
    }
  });

  const resendCodeHandler = () => {
    if (!email) return;
    throttledResendCode(email);
  };

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    const code = data.code.replaceAll(' ', '');
    throttledSubmit({ code });
  };

  React.useEffect(() => {
    setValue('code', formattedValue);
  }, [formattedValue, setValue]);

  React.useEffect(() => {
    const code = formattedValue.replaceAll(/\s/g, '');
    if (code.length === 6) {
      handleSubmit(onSubmit)();
    }
  }, [formattedValue]);

  return {
    codeRegister,
    resendCodeHandler,
    onSubmit,
    formattedValue,
    setFormattedValue
  };
};
